import React from "react";
import sd from "../assets/formalpic.jpeg";
import { motion } from "framer-motion";
import resumepdf from "../assets/SubhadipDas_Resume.pdf";
import Greet from "./Greet";

const Main = () => {
  return (
    <div className="">
      <Greet />
      <div className="card relative overflow-hidden p-5 m-5 sm:flex sm:justify-center sm:flex-row-reverse">
        <div
          className="pointer-events-none absolute inset-0 opacity-60 dark:opacity-40"
          aria-hidden="true"
        >
          <div className="absolute -top-24 -left-24 h-48 w-48 rounded-full bg-primary-300 blur-2xl"></div>
          <div className="absolute -bottom-16 -right-24 h-56 w-56 rounded-full bg-primary-500 blur-3xl"></div>
        </div>
        <div className="flex justify-center my-3 sm:pl-24 relative z-10">
          <motion.img
            className="w-full max-w-[260px] h-auto rounded-full dark:rounded-full shadow-2xl dark:shadow-zinc-800"
            src={sd}
            alt="Subhadip Das"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          />
        </div>
        <div className="py-3 sm:pr-24 relative z-10">
          <div className="flex space-x-4 sm:text-xl pb-2 font-serif">
            <span>I am</span>
            <motion.strong
              className="uppercase text-primary-600 text-2xl"
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
            >
              Subhadip Das
            </motion.strong>
          </div>
          <div className="sm:text-lg">Bachelor of Technology</div>
          <div className="sm:text-lg">Computer Science and Engineering</div>

          <div className="pt-4">
            <ul className="sm:text-lg space-y-1 overflow-x-scroll sm:overflow-hidden">
              <li>
                <i className="fa-solid fa-envelope mr-2"></i>
                Email:{" "}
                <a
                  href="mailto:subhadipdas4521@gmail.com"
                  className="hover:text-purple-800 dark:hover:text-purple-400"
                >
                  <label
                    title="Click here to send me email"
                    className="break-words cursor-pointer"
                  >
                    subhadipdas4521@gmail.com
                  </label>
                </a>
              </li>
              <li>
                <i className="fa-solid fa-phone mr-2"></i>
                Phone number:{" "}
                <a
                  href="tel:916295619720"
                  className="hover:text-purple-800 dark:hover:text-purple-400"
                >
                  <label
                    title="Click here to call me"
                    className="break-words cursor-pointer"
                  >
                    (+91) 6295619720
                  </label>
                </a>
              </li>
              <li>
                <i className="fa-brands fa-github mr-2"></i>
                Github profile:{" "}
                <a
                  className="hover:text-purple-800 dark:hover:text-purple-400"
                  href="https://github.com/Subhadip4521"
                  target="_blank"
                  rel="noreferrer"
                >
                  <label
                    title="Click here to visit Github"
                    className="break-words cursor-pointer"
                  >
                    github.com/Subhadip4521
                  </label>
                </a>
              </li>
              <li>
                <i className="fa-brands fa-linkedin mr-2"></i>
                Linkedin profile:{" "}
                <a
                  className="hover:text-purple-800 dark:hover:text-purple-400"
                  href="https://linkedin.com/in/subhadipdas4521/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <label
                    title="Click here to visit Linkedin"
                    className="break-words cursor-pointer"
                  >
                    linkedin.com/in/subhadipdas4521/
                  </label>
                </a>
              </li>
              <li>
                <i className="fa-solid fa-file mr-2"></i>
                My Resume:{" "}
                <a
                  href={resumepdf}
                  download={"SubhadipDas_Resume"}
                  className="hover:text-purple-800 dark:hover:text-purple-400"
                >
                  <label
                    title="Click here to download my resume"
                    className="break-words cursor-pointer"
                  >
                    Subhadip Das
                  </label>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
